import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/companies/list'
import { COOKIE_KEYS, getCookie } from '@features/General'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.onbordingOrganizer.historyImportAttendees

// This saga is for getting list of companies
function* listSagaTask({ payload }: TaskAction) {
    const event = getCookie(COOKIE_KEYS.ALA_EVENT)

    try {
        const params = {
            ...payload.pagination,
            query: payload.query,
            addPresignedURL: true
        }

        const response = yield axios.get(`/companies/imports`, {
            params,
            headers: {
                'event-id': event
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
